import { DefaultAfrrChronicleFilenameEnum, GroupKey, JBoxTypeKey, RampTestKey } from "../types";

export const JBOX_LABELS: Record<JBoxTypeKey, string> = {
  [JBoxTypeKey.JBox8Racks]: "JBox 8 racks",
  [JBoxTypeKey.JBox10Racks]: "JBox 10 racks",
  [JBoxTypeKey.JBox2]: "JBox 2",
};

export interface FieldConfig {
  key: string;
  label: string;
  defaultValue?: number;
  singleField?: boolean;
  helperText?: string;
}

export interface PlanningConfig {
  title: string;
  groupKey: GroupKey;
  fields: FieldConfig[];
}

const afrrFields = [
  { key: "initial_soc_restoration_power", label: "Initial SoC restoration power" },
  { key: "afrr_engagement_up", label: "AFRR engagement up" },
  { key: "afrr_engagement_down", label: "AFRR engagement down" },
  {
    key: "reactivity_delay",
    label: "Reactivity delay (ms)",
    singleField: true,
    helperText: "Between 0 and 1500 milliseconds",
  },
];

export const CONFIGS: PlanningConfig[] = [
  {
    title: "Plannings de soc management",
    groupKey: GroupKey.PlanningsSocManagement,
    fields: [
      { key: "target_soc", label: "Initial SoC" },
      { key: "duration", label: "Duration in Minutes", singleField: true },
    ],
  },
  {
    title: "Plannings AFRR - Phase 1 (first 15 min)",
    groupKey: GroupKey.PlanningsAfrrPhase1,
    fields: afrrFields,
  },
  {
    title: "Plannings AFRR - Phase 2 (next 20 min)",
    groupKey: GroupKey.PlanningsAfrrPhase2,
    fields: afrrFields,
  },
];

export const defaultChronicleFilenameMapping = {
  [RampTestKey.RampTest1]: DefaultAfrrChronicleFilenameEnum.R2Trial1,
  [RampTestKey.RampTest2]: DefaultAfrrChronicleFilenameEnum.R2Trial2,
};
